//libs
import { styled } from '@nykaa/ui-components';

//constants
import { MAX_DWEB_WIDTH } from 'shared/styles/base';

export const Wrapper = styled.div`
  max-width: ${MAX_DWEB_WIDTH}px;
  margin: 0 auto;
  overflow-x: clip;
`;
